import { auth } from "db/config";
import { signInWithEmailAndPassword } from "firebase/auth";

/**
 * Inicia sesión con email y contraseña
 */
export const login = async (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};
